import AbstractObserver from './abstract';

export default class HeaderFloatingObserver extends AbstractObserver {
  constructor(element) {
    super(element);
    this.dataSettings = this.element.hasAttribute('data-ua-header-options')
      ? JSON.parse(this.element.getAttribute('data-ua-header-options'))
      : {};
  }

  init() {
    this.offset = this.element.offsetTop;
    this.sections = this.element.querySelectorAll('.navbar-section');
    this.defaultState = true;
    return this;
  }

  destroy() {
    this.toDefaultState();
    return this;
  }

  check() {
    const docScrolled = window.scrollY;
    if (docScrolled > this.offset && this.defaultState) {
      this.changeState();
    } else if (docScrolled <= this.offset && !this.defaultState) {
      this.toDefaultState();
    }
    return this;
  }

  changeState() {
    this.toggleClasses('add', 'remove');
    this.defaultState = false;
    return this;
  }

  toDefaultState() {
    this.toggleClasses('remove', 'add');
    this.defaultState = true;
    return this;
  }

  toggleClasses(action1, action2) {
    this.element.classList[action1]('navbar-scrolled');
    this.element.classList[action1](this.dataSettings.fixMomentClasses);
    this.element.classList[action2](this.dataSettings.fixMomentExclude);

    if (this.sections.length) {
      this.sections.forEach(($section) => {
        const dataSettings = $section.hasAttribute('data-ua-navbar-item-options')
          ? JSON.parse($section.getAttribute('data-ua-navbar-item-options'))
          : {};
        $section.classList[action1](dataSettings.fixMomentClasses);
        $section.classList[action2](dataSettings.fixMomentExclude);
      });
    }
  }
}
